<template>
  <div class="customer-detail">
    <div class="customer-detail-title">
      <span></span>
      客户档案
      <van-icon
        name="edit"
        size="24"
        @click="editCustomer"
      />
    </div>
    <div class="customer-detail-main">
      <div class="customer-detail-box">
        <div class="customer-detail-box-title">
          基本信息
        </div>
        <div class="customer-detail-info">
          <el-form
            ref="form"
            :model="form"
            label-width="120px"
            size="mini"
          >
            <el-row :gutter="20">
              <el-col :span="8">

                <el-form-item label="卡号：">
                  <div class="customer-detail-info-value">
                    {{ detailInfo.user_cardno }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="客户名称：">
                  <div
                    class="customer-detail-info-value"
                    v-if="status === 'detail'"
                  >
                    {{ detailInfo.user_name }}
                  </div>
                  <el-input
                    v-model="form.user_name"
                    v-else
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="手机号：">
                  <div
                    class="customer-detail-info-value"
                    v-if="status === 'detail'"
                  >
                    {{ detailInfo.user_mobile }}
                  </div>
                  <el-input
                    v-model="form.user_mobile"
                    v-else
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="证件类型：">
                  <div
                    class="customer-detail-info-value"
                    v-if="status === 'detail'"
                  >
                    {{ idCardDict[detailInfo.document_type] }}
                  </div>
                  <el-select
                    v-model="form.document_type"
                    v-else
                  >
                    <el-option
                      v-for="item in Object.keys(idCardDict).map(key => {
                        return {
                            value: Number.parseInt(key),
                            label: idCardDict[key],
                        }
                      })"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>

                </el-form-item>
              </el-col>
              <!-- 证件号 -->
              <el-col :span="8">
                <el-form-item label="证件号：">
                  <div
                    class="customer-detail-info-value"
                    v-if="status === 'detail'"
                  >
                    {{ detailInfo.identification_number }}
                  </div>
                  <el-input
                    v-model="form.identification_number"
                    v-else
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="性别：">
                  <div
                    class="customer-detail-info-value"
                    v-if="status === 'detail'"
                  >
                    {{ detailInfo.user_sex_displayname }}
                  </div>
                  <el-select
                    v-model="form.user_sex"
                    v-else
                  >
                    <el-option
                      v-for="item in Object.keys(sexDict).map(key => {
                        return {
                            value: +key,
                            label: sexDict[key],
                        }
                      })"
                      :key="`user_sex${item.value}`"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="婚姻状况：">
                  <div
                    class="customer-detail-info-value"
                    v-if="status === 'detail'"
                  >
                    {{ maritalDict[detailInfo.maritaltype] }}
                  </div>
                  <el-select
                    v-model="form.maritaltype"
                    v-else
                  >
                    <el-option
                      v-for="item in Object.keys(maritalDict).map(key => {
                        return {
                            value: key,
                            label: maritalDict[key],
                        }
                      })"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="出生日期：">
                  <div
                    class="customer-detail-info-value"
                    v-if="status === 'detail'"
                  >
                    {{ detailInfo.user_birthday }}
                  </div>
                  <el-date-picker
                    v-else
                    v-model="form.user_birthday"
                    @change="onBirthdayChange"
                    type="date"
                  />
                </el-form-item>
              </el-col>
              <!-- 年龄 -->
              <el-col :span="8">
                <el-form-item label="年龄：">
                  <div
                    class="customer-detail-info-value"
                    v-if="status === 'detail'"
                  >
                    {{  detailInfo.age  }}
                  </div>
                  <el-input
                    disabled
                    v-model="form.age"
                    v-else
                  ></el-input>

                </el-form-item>
              </el-col>
              <!-- 综合等级 -->
              <el-col :span="8">
                <el-form-item label="综合等级：">
                  <div class="customer-detail-info-value">

                  </div>
                  <!-- <el-select
                    v-model="form.name"
                    v-else
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select> -->
                </el-form-item>
              </el-col>
              <!-- 消费等级 -->

              <el-col :span="8">
                <el-form-item label="消费等级：">
                  <div
                    class="customer-detail-info-value"
                    v-if="status === 'detail'"
                  >
                    {{ detailInfo.user_level_displayname }}
                  </div>
                  <el-select
                    v-model="form.user_level"
                    @change="onUserLevelChange"
                    v-else
                  >
                    <el-option
                      v-for="item in Object.keys(memberLevelDict).map(key => {
                            return {
                                value: +key,
                                label: memberLevelDict[key]
                            }
                          })"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 商保公司 -->
              <el-col :span="8">
                <el-form-item label="商保公司：">
                  <div class="customer-detail-info-value">

                  </div>
                  <!-- <el-select
                    v-model="form.name"
                    v-else
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select> -->
                </el-form-item>
              </el-col>

            </el-row>
          </el-form>

        </div>

      </div>
      <el-row
        type="flex"
        :gutter="20"
      >
        <el-col :span="12">
          <div class="customer-detail-box">
            <div class="customer-detail-box-title">
              客户来源
            </div>
            <div class="customer-detail-info">
              <el-form
                ref="form"
                :model="form"
                label-width="120px"
                size="mini"
              >
                <el-row :gutter="20">
                  <el-col :span="12">

                    <el-form-item label="所属渠道：">
                      <div
                        class="customer-detail-info-value"
                        v-if="status === 'detail'"
                      >
                        {{ detailInfo.scrm_account_name }}
                      </div>
                      <el-select
                        v-model="form.scrm_account_id"
                        v-else
                        @change="onChanellChange"
                      >
                        <el-option
                          v-for="item in channelColumns"
                          :key="item.channel_id"
                          :label="item.channel_name"
                          :value="item.channel_id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="渠道负责人：">
                      <div
                        class="customer-detail-info-value"
                        v-if="status === 'detail'"
                      >
                        {{ detailInfo.scrm_user_name }}
                      </div>
                      <el-input
                        v-model="form.scrm_user_name"
                        v-else
                        disabled
                      >
                      </el-input>

                    </el-form-item>
                  </el-col>
                  <el-col :span="12">

                    <el-form-item label="对接部门：">
                      <div
                        class="customer-detail-info-value"
                        v-if="status === 'detail'"
                      >

                      </div>
                      <el-input
                        v-else
                        disabled
                      >
                      </el-input>

                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="挂账公司：">
                      <div
                        class="customer-detail-info-value"
                        v-if="status === 'detail'"
                      >
                        {{ detailInfo.channel_account_company }}
                      </div>
                      <el-input
                        disabled
                        v-model="form.name"
                        v-else
                      ></el-input>
                    </el-form-item>
                  </el-col>

                </el-row>
              </el-form>

            </div>

          </div>
        </el-col>
        <el-col :span="12">
          <div class="customer-detail-box">
            <div class="customer-detail-box-title">
              联系信息
            </div>
            <div class="customer-detail-info">
              <el-form
                ref="form"
                :model="form"
                label-width="120px"
                size="mini"
              >
                <el-row>
                  <el-col :span="24">

                    <el-form-item label="户籍地址：">
                      <div
                        class="customer-detail-info-value"
                        v-if="status === 'detail'"
                      >
                        {{ detailInfo.registered_address }}

                      </div>
                      <el-input
                        v-model="form.registered_address"
                        v-else
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="联系地址：">
                      <div
                        class="customer-detail-info-value"
                        v-if="status === 'detail'"
                      >
                        {{ detailInfo.contact_address }}

                      </div>
                      <el-input
                        v-model="form.contact_address"
                        v-else
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">

                    <el-form-item label="联系方式：">
                      <div
                        class="customer-detail-info-value"
                        v-if="status === 'detail'"
                      >
                        {{ detailInfo.user_mobile }}
                      </div>
                      <el-input
                        v-model="form.user_mobile"
                        v-else
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>

            </div>

          </div>
        </el-col>
      </el-row>
      <el-row
        type="flex"
        :gutter="20"
      >
        <el-col :span="12">
          <div class="customer-detail-box">
            <div class="customer-detail-box-title">
              会员信息
            </div>
            <div class="customer-detail-info">
              <el-form
                ref="form"
                :model="form"
                label-width="120px"
                size="mini"
              >
                <el-row :gutter="20">
                  <el-col :span="8">

                    <el-form-item label="是否会员：">
                      <div
                        class="customer-detail-info-value"
                        v-if="status === 'detail'"
                      >

                      </div>
                      <el-input
                        v-else
                        disabled
                      ></el-input>

                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="会员类型：">
                      <div
                        class="customer-detail-info-value"
                        v-if="status === 'detail'"
                      >
                        {{ detailInfo.user_level_type_name }}
                      </div>
                      <el-select
                        v-model="form.user_level_type"
                        v-else
                      >
                        <el-option
                          v-for="item in Object.keys(memberTypeDict).map(key => {
                            return {
                                value: key,
                                label: memberTypeDict[key]
                            }
                          })"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">

                    <el-form-item label="会员等级：">
                      <div
                        class="customer-detail-info-value"
                        v-if="status === 'detail'"
                      >
                        {{ detailInfo.user_level_displayname }}
                      </div>
                      <el-select
                        v-model="form.user_level"
                        @change="onUserLevelChange"
                        v-else
                      >
                        <el-option
                          v-for="item in Object.keys(memberLevelDict).map(key => {
                            return {
                                value: +key,
                                label: memberLevelDict[key]
                            }
                          })"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="会员起始日期：">
                      <div
                        class="customer-detail-info-value"
                        v-if="status === 'detail'"
                      >

                      </div>
                      <el-input
                        v-else
                        disabled
                      ></el-input>

                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="会员截至日期：">
                      <div
                        class="customer-detail-info-value"
                        v-if="status === 'detail'"
                      >
                      </div>
                      <el-input
                        v-else
                        disabled
                      ></el-input>

                    </el-form-item>
                  </el-col>

                </el-row>
              </el-form>

            </div>

          </div>
        </el-col>
        <el-col :span="12">
          <div class="customer-detail-box">
            <div class="customer-detail-box-title">
              服务信息
            </div>
            <div class="customer-detail-info">
              <el-form
                ref="form"
                :model="form"
                label-width="120px"
                size="mini"
              >
                <el-row :gutter="20">
                  <el-col :span="24">

                    <el-form-item label="服务管家：">
                      <div
                        class="customer-detail-info-value"
                        v-if="status === 'detail'"
                      >
                        {{ detailInfo.service_butler }}
                      </div>
                      <el-input
                        v-model="form.service_butler"
                        disabled
                        v-else
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="家庭医生：">
                      <div
                        class="customer-detail-info-value"
                        v-if="status === 'detail'"
                      >
                        {{ detailInfo.family_doctor }}
                      </div>
                      <el-input
                        v-model="form.family_doctor"
                        disabled
                        v-else
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">

                    <el-form-item label="医助：">
                      <div
                        class="customer-detail-info-value"
                        v-if="status === 'detail'"
                      >
                        {{ detailInfo.medical_assistance }}

                      </div>
                      <el-input
                        v-model="form.medical_assistance"
                        disabled
                        v-else
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>

            </div>

          </div>
        </el-col>
      </el-row>
      <div class="customer-detail-box">
        <div class="customer-detail-box-title">
          服务记录
          <!-- <el-button
            type="primary"
            size="mini"
          >主要按钮</el-button> -->
        </div>
        <div class="customer-detail-info">
          <el-table
            :data="tableData"
            style="width: 100%"
            height="calc(100vh - 50px)"
          >
            <el-table-column
              prop="appointment_id"
              label="预约单号"
            >
            </el-table-column>
            <el-table-column
              prop="appointment_number"
              label="his预约单号"
            >
            </el-table-column>
            <el-table-column
              prop="appointment_change"
              label="改约标识"
            >
            </el-table-column>
            <el-table-column
              prop="appointment_remark"
              label="预约备注"
            >
            </el-table-column>

            <el-table-column
              prop="visit_type"
              label="就诊状态"
            >
            </el-table-column>
            <el-table-column
              prop="report_schedule"
              label="报告生成状态"
            >
            </el-table-column>
            <el-table-column
              prop="hospital_area"
              label="院区"
            >
            </el-table-column>
            <el-table-column
              prop="bussiness_type"
              label="业务类型"
            >
            </el-table-column>
            <el-table-column
              prop="examination_type"
              label="体检类型"
            >
            </el-table-column>
            <el-table-column
              prop="visit_code"
              label="就诊原因"
            >
            </el-table-column>
            <el-table-column
              prop="package_name"
              label="套餐"
            >
            </el-table-column>
            <el-table-column
              prop="department"
              label="科室"
            >
            </el-table-column>
            <el-table-column
              prop="doctor_name"
              label="医生"
            >
            </el-table-column>
            <el-table-column
              prop="appointment_date"
              label="预约时间"
            >
            </el-table-column>
            <el-table-column
              prop="start_time"
              label="起始时间"
            >
            </el-table-column>
            <el-table-column
              prop="end_time"
              label="截止时间"
            >
            </el-table-column>
            <el-table-column
              prop="appointment_channel"
              label="预约渠道"
            >
            </el-table-column>
            <el-table-column
              prop="visit_time"
              label="就诊时间"
            >
            </el-table-column>

            <el-table-column
              prop="address"
              label="是否需要纸质报告"
            >
            </el-table-column>
            <el-table-column
              prop="address"
              label="纸质报告快递单号"
            >
            </el-table-column>

            <el-table-column
              prop="complete_time"
              label="完成时间"
            >
            </el-table-column>
            <el-table-column
              prop="reference"
              label="推荐人"
            >
            </el-table-column>
          </el-table>
        </div>

      </div>
    </div>
    <div
      class="customer-detail-footer"
      v-if="status === 'edit'"
    >
      <el-button
        type="info"
        size="mini"
        @click="onCancel"
      >取消</el-button>
      <el-button
        type="primary"
        @click="onSave"
        size="mini"
        :loading="submiting"
      >保存</el-button>
    </div>

  </div>
</template>

<script>
import hisService from "@/apis/his/index";
import cuotomerService from "@/apis/customer/index.js";
import { deepClone } from "@/utils/utils";
import { Message } from "element-ui";

const idCardDict = {
  1: "身份证",
  2: "工作证",
  3: "学生证",
  4: "军官证",
  5: "暂住证",
  6: "低保证",
  7: "医保手册",
  8: "驾照",
  9: "户口本",
  10: "士兵证",
  11: "回乡证",
  12: "临时身份证",
  13: "警官证",
  14: "外国人永久居留证",
  17: "海员证",
  18: "港澳居民来往内地通行证",
  19: "台胞证",
  97: "护照",
  98: "出生证明",
  99: "其他",
};

const sexDict = {
  0: "未知",
  1: "男",
  2: "女",
  9: "其他",
};

const maritalDict = {
  10: "未婚",
  20: "已婚",
  90: "未知",
};

const memberTypeDict = {
  1: "储值金会员",
  2: "非会员",
  3: "圆和会员",
};

const memberLevelDict = {
  20584654: "A+",
  20584788: "A级",
  20584818: "B级",
  20584827: "C级",
  1421180: "D级",
};

export default {
  data() {
    return {
      maritalDict,
      sexDict,
      idCardDict,
      memberTypeDict,
      memberLevelDict,
      detailInfo: {},
      status: "detail",
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },

      tableData: [],
      channelColumns: [],
      submiting: false,
    };
  },
  created() {
    this.getAllChanell();
    this.getDetail();
  },
  mounted() {},
  methods: {
    editCustomer() {
      if (this.type === "edit") return;
      this.form = deepClone(this.detailInfo);
      this.status = "edit";
    },
    getDetail() {
      const params = {
        msg_type: "OutpatientDepartment.BaesInfoCore.FindUserInfo",
        logistics_interface: JSON.stringify({
          patientId: this.$route.query.patientId,
        }),
      };
      hisService.mainMethod(params).then((res) => {
        this.tableData = res[0].AppointmentInfos;
        res[0].age = this.getAge(res[0].user_birthday);
        this.detailInfo = res[0];
        console.log(res);
      });
    },
    getAllChanell() {
      const params = {
        filter: "",
      };
      cuotomerService.scrmAccounts(params).then((res) => {
        if (res && res.length > 0) {
          res.forEach((item) => {
            item.showName = `${item.account_name}(${item.user_name})`;
          });
          this.channelColumns = res;
        } else {
          this.channelColumns = [];
        }
      });
    },
    onBirthdayChange(val) {
      this.form.age = this.getAge(val);
    },
    onUserLevelChange(value) {
      this.form.user_level_displayname = memberLevelDict[value];
    },
    onChanellChange(value) {
      const { channelColumns } = this;
      let selectChannel = channelColumns.find(
        (item) => item.account_id === value
      );
      this.form.scrm_user_name = selectChannel.channel_manager;
      this.form.channel_account_company = selectChannel.channel_account_company;
    },
    // 根据出生日期计算年龄
    getAge(birthday) {
      const now = new Date();
      const birth = new Date(birthday);
      let age = now.getFullYear() - birth.getFullYear();
      const m = now.getMonth() - birth.getMonth();
      if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) {
        age--;
      }
      return age;
    },
    onSave() {
      const { form } = this;
      const data = {
        patient_id: form.patientId,
        patient_name: form.user_name,
        patient_phone: form.user_mobile,
        card_type: form.document_type,
        card_number: form.identification_number,
        patient_sex: form.user_sex,
        marital_type: form.maritaltype || "",
        patient_birthday: form.user_birthday,
        user_level: form.user_level,
        user_level_type: form.user_level_type,
        contact_address: form.contact_address || "",
        registered_address: form.registered_address || "",
        channel_id: form.scrm_account_id,
        // service_butler: form.service_butler || "",
        // family_doctor: form.family_doctor || "",
        // medical_assistance: form.medical_assistance || "",
      };

      //   form.marital_type = form.marital_type;
      const params = {
        msg_type: "OutpatientDepartment.BaesInfoCore.UpdatePatientInfo",
        logistics_interface: JSON.stringify(data),
      };
      this.submiting = true;
      hisService
        .mainMethod(params)
        .then((res) => {
          Message({
            type: "success",
            message: "保存成功",
          });
          this.getDetail();
          this.status = "detail";
          this.submiting = false;
          console.log(res);
        })
        .catch(() => {
          this.submiting = false;
        });
    },
    onCancel() {
      this.status = "detail";
    },
  },
};
</script>

<style lang="scss" scoped>
.customer-detail {
  padding: 20px;
  overflow: auto;
  height: 100vh;
  box-sizing: border-box;
  .el-col {
    height: auto;
  }
  .el-row {
    margin-bottom: 20px;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
}
.customer-detail-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.customer-detail-box {
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  height: 100%;
  box-sizing: border-box;
}
.customer-detail-footer {
  display: flex;
  justify-content: center;
}
.customer-detail-box-title {
  font-weight: 900;
}
</style>